import { webConfig } from '@gitbook/env';
import { startSentryReplay } from '@gitbook/util-debug';
import { localStorage } from '@gitbook/util-local-storage';

const STORAGE_KEY = 'sentryReplayEnabled';

const isSentryReplayBlocked = !webConfig.sentry.recordReplays;
export const isSentryReplayEnabled = !isSentryReplayBlocked && !!localStorage.get(STORAGE_KEY);

/**
 * Enable Sentry replay for the future sessions.
 */
export function enableSentryReplay() {
    if (isSentryReplayEnabled || isSentryReplayBlocked) {
        return;
    }
    localStorage.set(STORAGE_KEY, true);
    startSentryReplay();
}

/**
 * Disable Sentry replay for the future sessions.
 */
export function disableSentryReplay() {
    if (!isSentryReplayEnabled || isSentryReplayBlocked) {
        return;
    }
    localStorage.set(STORAGE_KEY, false);
}
